import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import AuthWrapper from './components/AuthWrapper';
import SEOLandingPage from './components/SEOLandingPage';
import SitemapGenerator from './components/SitemapGenerator';
import Analytics from './components/Analytics';
import HomePage from './pages/HomePage';
import ConceptualEstimate from './pages/ConceptualEstimate';
import QuestionFlow from './pages/QuestionFlow';
import CostEstimate from './pages/CostEstimate';
import DrawingEstimate from './pages/DrawingEstimate';
import QuoteChecker from './pages/QuoteChecker';
import QuoteChanges from './pages/QuoteChanges';
import BlogPost from './pages/BlogPost';
import BlogIndex from './pages/BlogIndex';
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthWrapper>
          <div className="min-h-screen">
            <Navigation />
            <SitemapGenerator />
            <Analytics />
            <Routes>
              <Route path="/" element={<div className="bg-gray-50"><HomePage /></div>} />
              <Route path="/conceptual-estimate" element={<div className="bg-gray-50"><ConceptualEstimate /></div>} />
              <Route path="/question-flow" element={<QuestionFlow />} />
              <Route path="/cost-estimate" element={<div className="bg-gray-50"><CostEstimate /></div>} />
              <Route path="/drawing-estimate" element={<DrawingEstimate />} />
              <Route path="/quote-checker" element={<QuoteChecker />} />
              <Route path="/quote-changes" element={<QuoteChanges />} />
              
              {/* Blog Routes - Main */}
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              
              {/* Blog Routes - Alternative URLs for SEO */}
              <Route path="/tools/:slug" element={<BlogPost />} />
              <Route path="/software/:slug" element={<BlogPost />} />
              <Route path="/guides/:slug" element={<BlogPost />} />
              <Route path="/reviews/:slug" element={<BlogPost />} />
              <Route path="/construction-tools/:slug" element={<BlogPost />} />
              <Route path="/construction-software/:slug" element={<BlogPost />} />
              <Route path="/estimating-tools/:slug" element={<BlogPost />} />
              <Route path="/ai-tools/:slug" element={<BlogPost />} />
              
              {/* Comprehensive SEO Landing Pages */}
              <Route path="/estimate/:projectType/:state" element={<SEOLandingPage />} />
              <Route path="/estimate/:projectType/:state/:city" element={<SEOLandingPage />} />
              
              {/* Alternative SEO URL patterns for maximum coverage */}
              <Route path="/cost/:projectType/:state" element={<SEOLandingPage />} />
              <Route path="/cost/:projectType/:state/:city" element={<SEOLandingPage />} />
              <Route path="/calculator/:projectType/:state" element={<SEOLandingPage />} />
              <Route path="/calculator/:projectType/:state/:city" element={<SEOLandingPage />} />
              <Route path="/pricing/:projectType/:state" element={<SEOLandingPage />} />
              <Route path="/pricing/:projectType/:state/:city" element={<SEOLandingPage />} />
              <Route path="/budget/:projectType/:state" element={<SEOLandingPage />} />
              <Route path="/budget/:projectType/:state/:city" element={<SEOLandingPage />} />
              
              {/* Project type variations */}
              <Route path="/estimate/:variation/:state" element={<SEOLandingPage />} />
              <Route path="/cost/:variation/:state" element={<SEOLandingPage />} />
              
              {/* 404 Catch-all Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </AuthWrapper>
      </Router>
    </HelmetProvider>
  );
}

export default App;
